/**
 * Therapist API functions
 */

import { apiClient } from '../api-client';

// ============= Type Definitions =============

export interface ExercisePlanCreate {
  patient_id: number;
  plan_name: string;
  exercises: Array<{
    type: string;              // Exercise type (Breathing, Stretching, etc.)
    name: string;              // Exercise name
    sets: number;
    reps: number;
    duration: number;          // Duration in MINUTES (not seconds)
    intensity: string;         // Low, Moderate, High
    frequency: number;         // Times per week
    progressive_load: string;  // Progressive load plan
    notes?: string;
  }>;
  status: string;              // 'draft' or 'active'
  start_date?: string;
  end_date?: string;
  notes?: string;
}

export const therapistsApi = {
  /**
   * Get list of all therapists
   */
  getTherapists: async (): Promise<any> => {
    return apiClient.get('/therapists');
  },

  /**
   * Get therapist by ID
   */
  getTherapist: async (therapistId: number): Promise<any> => {
    return apiClient.get(`/therapists/${therapistId}`);
  },

  /**
   * Get therapist dashboard summary (current logged-in therapist)
   */
  getTherapistDashboardSummary: async (): Promise<any> => {
    return apiClient.get('/therapists/me/summary');
  },

  /**
   * Create a new exercise plan for a patient
   */
  createExercisePlan: async (data: ExercisePlanCreate): Promise<any> => {
    return apiClient.post('/therapists/exercise-plans', data);
  },
};